import React, {useState} from 'react';

import {AttachmentFullscreen} from 'src/components/trigger-attachment/attachment-fullscreen';
import {AttachmentUpload} from 'src/components/trigger-attachment/attachment-upload';
import {MAX_ACTIVE_ATTACHMENTS_COUNT} from 'src/constants';
import {EventCreationMode} from 'src/modules/event-create/constants';
import {TRIGGER_ATTACHMENTS_INFO} from 'src/modules/event-create/event-create-hovers';
import {
    AttachmentPreview,
} from 'src/modules/event-create/header-block/event-trigger-attachment/attachment-preview/attachment-preview';
import {
    useEventTriggerAttachment,
} from 'src/modules/event-create/header-block/event-trigger-attachment/hooks/useEventTriggerAttachment';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';
import {EventType} from 'src/openapi/models/EventType';
import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

import Carousel, {CarouselItem} from '@pb/kit-component-carousel';
import {Dropdown} from '@pb/kit-component-dropdown-v2';
import {Group} from '@pb/kit-component-group';
import {InfoIconButton} from '@pb/kit-component-icon-button';

type Props = {
    mode: EventCreationMode,
    eventChangeRequest: EventChangeRequest,
    validationHighLight: boolean,
    isUploading: boolean,
    onUploadFiles: (acceptedFiles: File[]) => void,
};

export const EventTriggerAttachmentView = (props: Props) => {
    const {
        mode,
        eventChangeRequest,
        validationHighLight,
        isUploading,
        onUploadFiles,
    } = props;

    const {triggerAttachments, activeTriggerAttachmentsCount} = useEventTriggerAttachment();
    const [fullscreen, setFullscreen] = useState<TriggerAttachment | null>(null);

    const isUpdateMode = mode === EventCreationMode.update;
    const isUserEvent = eventChangeRequest.type === EventType.USER_EVENT;
    const hasNoActiveTriggerAttachments = activeTriggerAttachmentsCount === 0;
    const isDeprecated = eventChangeRequest.deprecated;

    const hasValidationHighLight = Boolean(validationHighLight && isUpdateMode && isUserEvent
        && !isDeprecated && hasNoActiveTriggerAttachments);

    return (
        <Group direction="v" gap="xxs">
            <Group gap="xs" alignItems="center" justify="start">
                <strong>Attachments:</strong>
                <Dropdown
                    hoverEnabled={true}
                    clickEnabled={false}
                    maxWidth={500}
                    anchor={({anchorRef, getAnchorProps}) => (
                        <InfoIconButton {...getAnchorProps()} ref={anchorRef}/>
                    )}>
                    {TRIGGER_ATTACHMENTS_INFO}
                </Dropdown>
            </Group>
            <Carousel key={`${hasValidationHighLight}|${isUploading}`} slidesGap={5}>
                {triggerAttachments.map((attachment: TriggerAttachment) => (
                    <CarouselItem id={attachment.name} key={attachment.name}>
                        <AttachmentPreview
                            attachment={attachment}
                            setFullscreen={setFullscreen}
                        />
                    </CarouselItem>
                ))}
                {activeTriggerAttachmentsCount < MAX_ACTIVE_ATTACHMENTS_COUNT && (
                    <CarouselItem id="attachment-upload">
                        <AttachmentUpload
                            isUploading={isUploading}
                            validationHighLight={hasValidationHighLight}
                            onUploadFiles={onUploadFiles}
                        />
                    </CarouselItem>
                )}
            </Carousel>
            <AttachmentFullscreen
                attachment={fullscreen}
                setFullscreen={setFullscreen}
            />
        </Group>
    );
};
